export const HOBBIES = [
  'Music', 'Art', 'Soccer', 'Football', 'Basketball', 'Tennis', 'Gaming',
  'Reading', 'Travel', 'Cooking', 'Baking', 'Hiking', 'Dancing', 'Fishing',
  'Chess', 'Movies', 'Fashion', 'Coding', 'Yoga', 'Running', 'Singing',
  'Cycling', 'Drawing', 'Painting', 'Swimming', 'Writing', 'Anime', 'Cars',
  'Nature', 'Fitness', 'Guitar', 'Piano', 'Camping', 'Skating', 'Surfing',
  'Boxing', 'Photography', 'Gardening', 'Podcasts', 'Design', 'Animals'
]

export const parseHobbies = (raw) => String(raw || '')
  .split(/[,|]/)
  .map(item => item.trim())
  .filter(Boolean)

export const joinHobbies = (list) => list.filter(Boolean).join(', ').slice(0, 200)

export const hobbySuggestions = (query, selected = [], limit = 8) => {
  const q = String(query || '').trim().toLowerCase()
  const taken = new Set((selected || []).map(item => String(item).toLowerCase()))
  const list = HOBBIES.filter(item => {
    const name = item.toLowerCase()
    if (taken.has(name)) return false
    return q ? name.includes(q) : true
  })
  return list.slice(0, limit)
}

export const ageFromBirthday = (iso) => {
  const born = new Date(`${iso}T00:00:00`)
  if (!iso || Number.isNaN(born.getTime())) return ''
  const now = new Date()
  let years = now.getFullYear() - born.getFullYear()
  const month = now.getMonth() - born.getMonth()
  if (month < 0 || (month === 0 && now.getDate() < born.getDate())) years -= 1
  if (years < 0 || years > 120) return ''
  return years
}
